module.exports = __webpack_public_path__ + "img/구름조금.85e3cbad.png";